import { render, staticRenderFns } from "./estoqueMedicamentos.vue?vue&type=template&id=4b7e5256&scoped=true&"
import script from "./estoqueMedicamentos.vue?vue&type=script&lang=js&"
export * from "./estoqueMedicamentos.vue?vue&type=script&lang=js&"
import style0 from "./estoqueMedicamentos.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./estoqueMedicamentos.vue?vue&type=style&index=1&id=4b7e5256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e5256",
  null
  
)

export default component.exports